import React, { useEffect, useRef, useState } from "react";
import styles from "./autoComplete.module.scss";
import { Suggestion } from "./Suggestion";
import { Input } from "superbid-ui";
import WishlistService from "services/wishListService";
import { InputTag } from "components/ui_kit/InputTag";

interface AutoCompleteProps {
    children?: any;
    onChange?: (data: any) => void;
    onClick?: (data: any) => void;
    tagDelete?: (data: any) => void;
    placeholder?: string;
    name?: string;
    value?: any;
    isErrored?: boolean;
}

export const AutoComplete: React.FC<AutoCompleteProps> = ({
    onClick,
    onChange,
    name,
    placeholder,
    value,
    isErrored = false,
    tagDelete,
}) => {
    const [suggestion, setSuggestion] = useState<any>([]);
    const [isVisible, setIsVisible] = useState(false);
    const [onTag, setOnTag] = useState(false);

    const activeVisible = useRef(null);
    function handleClickOutside(event) {
        if (activeVisible && !activeVisible?.current?.contains(event.target)) {
            setIsVisible(false);
        }
    }

    const getWishList = async (text) => {
        if (text !== "") {
            try {
                const wishListService = new WishlistService();
                const { data } = await wishListService.getSearch(text);
                const response = [];
                data.forEach((e) => {
                    response.push(e);
                });
                setSuggestion(response);
            } catch (error) {
                console.log(error);
            }
        }
    };
    const handleChange = (text) => {
        onChange(text);
        getWishList(text);
    };

    useEffect(() => {
        if (!isVisible && activeVisible) {
            document.addEventListener("click", handleClickOutside);
        }

        return () => document.removeEventListener("click", handleClickOutside);
    }, []);

    useEffect(() => {
        if (suggestion.length) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    }, [suggestion]);

    return (
        <div ref={activeVisible} className={styles.box}>
            <div className={styles.box_input}>
                <InputTag
                    value={value}
                    name={name}
                    onChange={(value: any) => handleChange(value)}
                    isErrored={isErrored}
                    placeholder={placeholder}
                    tagDelete={(value) => {
                        tagDelete(value);
                        setOnTag(false);
                    }}
                    onTag={onTag}
                />
            </div>
            {isVisible ? (
                <div className={styles.box__suggestion}>
                    <Suggestion
                        data={suggestion}
                        onClick={(item) => {
                            const { brand, model } = item;
                            brand && model && setOnTag(true);
                            setIsVisible(false);
                            onClick(item);
                        }}
                    />
                </div>
            ) : (
                false
            )}
        </div>
    );
};
